<template>
  <div>
    <div class="main-profile" v-if="!accountsLoading" :style="siteStyles">
      <div class="profile-header">
        <h1 v-if="showAccount || manageDelivery || taxFormsVisible" class="move-left" @click="setAccount"><v-icon :color="primaryColor">navigate_before</v-icon>MY DOCUMENTS</h1>
        <h1 v-else>MY DOCUMENTS</h1>
        <div @click="enableManage" v-if="!manageDelivery" class="sub-profile-header">Manage Document Delivery</div>
      </div>
      <div class="main-box profile-border">
            <v-layout row wrap>
              <v-flex v-if="manageDelivery" class="doc-delivery">
                <div class="main-blue mb-2">Manage document delivery</div>
                <p class="welcome-text">Choose how you would like to receive your account documents. You can update your delivery preferences at any time. If you choose online delivery, a notification will be sent to <span>{{ userDetails.email }}</span>.</p>
                <div class="all-online">
                  <v-checkbox
                    class="online pa-0 ma-0"
                    v-model="allOnline"
                    label="Choose online for all"
                    :color="appColor"
                    hide-details
                  ></v-checkbox>
                </div>
                <div class="user-accounts">
                  <div class="account-row" v-for="acc in filteredUserAccounts">
                    <div class="account-group">
                      <div @click="selectAccount(acc)" class="account-name">{{ acc.accountNickname ? acc.accountNickname : acc.accountName }}</div>
                      <div class="account-number">{{ acc.container }} &#8226; {{ acc.accountNumberMasked }}</div>
                    </div>
                    <v-radio-group
                      v-if="!acc.myDocumentData.isExternal"
                      class="delivery-pref"
                      row
                      hide-details
                      @click.stop="checkUpdate(acc)"
                      v-model="acc.myDocumentData.deliveryPreference"
                      :readonly="acc.container === '401K'"
                    >
                      <v-radio color="#6E6E6E" value="electronic">
                        <div slot="label" class="radio-label">Online</div>
                      </v-radio>
                      <v-radio color="#6E6E6E" value="paper">
                        <div slot="label" class="radio-label">Mail</div>
                      </v-radio>
                    </v-radio-group>
                    <v-btn :color="primaryColor" dark v-else class="external" small @click.stop="goToUrl(acc.myDocumentData.systemLink)">{{ acc.myDocumentData.systemGroup }} Statements</v-btn>
                  </div>
                  <div class="button-row">
                    <v-btn dark depressed :color="buttonColor" class="" :loading="preferencesLoading" @click="sendPreferenceUpdate">Save</v-btn>
                  </div>
                </div>
              </v-flex>
              <v-flex v-else-if="!showAccount && !taxFormsVisible">
                <div class="main-blue">Find all documents related to your accounts below</div>
                <div class="user-accounts">
                  <div class="account-row" v-for="acc in userAccounts">
                    <div class="account-group">
                      <div @click="selectAccount(acc)" class="account-name">{{ acc.accountNickname ? acc.accountNickname : acc.accountName }}</div>
                      <div class="account-number">{{ acc.container }} &#8226; {{ acc.accountNumberMasked }}</div>
                    </div>
                  </div>
                </div>
                <v-layout row wrap>
                  <v-flex d-flex xs12 md6>
                    <v-layout class="manage-documents">
                      <v-flex shrink class="mr-2">
                        <v-img
                          :src="require('@/assets/imgs/tax-forms.svg')"
                          width="95px"
                          height="95px"
                        />
                      </v-flex>
                      <v-flex shrink class="mr-4">
                        <p class="mb-0">Easy access to your tax information.</p>
                        <div @click="showTaxForms" class="account-name">View All Tax Forms</div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex d-flex xs12 md6>
                    <v-layout class="manage-documents">
                      <v-flex shrink class="mr-2">
                        <v-img
                          :src="require('@/assets/imgs/managed-docs.svg')"
                          width="95px"
                          height="95px"
                        />
                      </v-flex>
                      <v-flex shrink>
                        <p class="mb-0">Go paperless with online documents.</p>
                        <a @click="enableManage" class="account-name">Manage Document Delivery</a>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex v-else-if="taxFormsVisible">
                <div class="main-blue mb-2">Tax Forms</div>
                <v-expansion-panel v-model="getTaxFormsVal">
                  <v-expansion-panel-content
                    v-for="(year,i) in taxYears"
                    :key="i"
                    class="doc-type"
                  >
                  <template v-slot:header>
                      <div class="type-name">{{ year }}</div>
                    </template>
                    <template v-slot:actions>
                      <v-icon :color="primaryColor">expand_more</v-icon>
                    </template>
                    <template v-slot:default>
                      <div class="user-statements" v-if="userStatements.length">
                        <div class="account-statement" v-for="(statement,i) in userStatements" :key="i">
                          <div @click="requestStatement(statement, formatTaxDocumentName(statement), i)" class="statement-name">
                            <v-icon small :color="primaryColor" class="mr-1">description</v-icon>{{ formatTaxDocumentName(statement) }}
                            <v-progress-circular
                              v-if="statementDownloading && i === clicked"
                              indeterminate
                              size="18"
                              width="3"
                              :color="primaryColor"
                              class="ml-2"
                            ></v-progress-circular>
                          </div>
                        </div>
                      </div>
                      <div class="account-statement" v-else-if="statementsLoading">Loading documents...</div>
                      <div class="account-statement" v-else>No documents found</div>
                    </template>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-layout row wrap>
                  <v-flex d-flex xs12 md6>
                    <v-layout class="manage-documents">
                      <v-flex shrink class="mr-2">
                        <v-img
                          :src="require('@/assets/imgs/managed-docs.svg')"
                          width="95px"
                          height="95px"
                        />
                      </v-flex>
                      <v-flex shrink>
                        <p class="mb-0">Go paperless with online documents.</p>
                        <a @click="enableManage" class="account-name">Manage Document Delivery</a>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex v-else>
                <div class="main-blue mb-0">{{ currentAccount.accountNickname ? currentAccount.accountNickname : currentAccount.accountName }}</div>
                <div class="account-number mt-0 mb-4">{{ currentAccount.container }} &#8226; {{ currentAccount.accountNumberMasked }}</div>
                <v-expansion-panel v-model="openType">
                  <v-layout row wrap align-center>
                    <v-flex xs6 sm4 lg3 class="input-group pr-3">
                      <div class="Input__inputLabel___3VF0S">Start Date:</div>
                      <v-menu
                        v-model="startMenu"
                        :close-on-content-click="false"
                        lazy
                        transition="scale-transition"
                        offset-y
                        nudge-bottom="15"
                        nudge-left="17"
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="startDateFormatted"
                            append-icon="event"
                            :color="primaryColor"
                            readonly
                            v-on="on"
                            class="date-pick"
                            hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker no-title :color="primaryColor" :max="(new Date()).toISOString()" v-model="startDate" @input="startMenu = false"></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs6 sm4 lg3 class="input-group pr-3">
                      <div class="Input__inputLabel___3VF0S">End Date:</div>
                      <v-menu
                        v-model="endMenu"
                        :close-on-content-click="false"
                        lazy
                        nudge-bottom="15"
                        nudge-left="17"
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :color="primaryColor"
                            v-model="endDateFormatted"
                            append-icon="event"
                            readonly
                            v-on="on"
                            class="date-pick"
                            hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker no-title :color="primaryColor" :max="(new Date()).toISOString()"  v-model="endDate" @input="endMenu = false"></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex class="group-btn">
                      <v-btn dark depressed :color="buttonColor" class="ma-0" :loading="statementsLoading" @click="selectType(currentItem)">View</v-btn>
                    </v-flex>
                  </v-layout>
                  <v-expansion-panel-content
                    v-for="(type,i) in filteredDocTypes"
                    :key="i"
                    class="doc-type"
                  >
                    <template v-slot:header>
                      <div class="type-name">{{ type.name }}</div>
                    </template>
                    <template v-slot:actions>
                      <v-icon :color="primaryColor">expand_more</v-icon>
                    </template>
                    <template v-slot:default>
                      <div class="user-statements" v-if="userStatements.length">
                        <div class="account-statement" v-for="(statement,i) in userStatements" :key="i">
                          <div @click="requestStatement(statement, formatDocumentName(statement), i)" class="statement-name">
                            <v-icon small :color="primaryColor" class="mr-1">description</v-icon>
                            {{ formatDocumentName(statement) }}
                            <v-progress-circular
                              v-if="statementDownloading && i === clicked"
                              indeterminate
                              size="18"
                              width="3"
                              :color="primaryColor"
                              class="ml-2"
                            ></v-progress-circular>
                          </div>
                        </div>
                      </div>
                      <div class="account-statement" v-else-if="statementsLoading">Loading {{ filteredDocTypes[openType].name }}...</div>
                      <div class="account-statement" v-else>No {{ filteredDocTypes[openType].name }} Found</div>
                    </template>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-layout row wrap>
                  <v-flex d-flex xs12 md6>
                    <v-layout class="manage-documents">
                      <v-flex shrink class="mr-2">
                        <v-img
                          :src="require('@/assets/imgs/tax-forms.svg')"
                          width="95px"
                          height="95px"
                        />
                      </v-flex>
                      <v-flex shrink class="mr-4">
                        <p class="mb-0">Easy access to your tax information.</p>
                        <div @click="showTaxForms" class="account-name">View All Tax Forms</div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex d-flex xs12 md6>
                    <v-layout class="manage-documents">
                      <v-flex shrink class="mr-2">
                        <v-img
                          :src="require('@/assets/imgs/managed-docs.svg')"
                          width="95px"
                          height="95px"
                        />
                      </v-flex>
                      <v-flex shrink>
                        <p class="mb-0">Go paperless with online documents.</p>
                        <a @click="enableManage" class="account-name">Manage Document Delivery</a>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
      </div>
    </div>
    <div class="loading-profile" v-else>
      <!-- <v-progress-linear height="4" color="#40A8CB" :indeterminate="true"></v-progress-linear> -->
      <hollow-dots-spinner
        :animation-duration="1500"
        :dot-size="20"
        :dots-num="3"
        :color="borderColor"
      />
    </div>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
import { HollowDotsSpinner } from 'epic-spinners'
import { mapState, mapGetters } from "vuex";
import { $authUser } from "@/plugins/axios";
export default {
  name: "options",
  data() {
    return {
      dateTest: null,
      startDate: this.$moment().subtract(6, "months").toISOString().substr(0, 10),
      endDate: this.$moment().toISOString().substr(0, 10),
      startMenu: false,
      endMenu: false,
      currentStart: "",
      currentEnd: "",
      clicked: null,
      showAccount: false,
      taxFormsVisible: false,
      preferenceLoadingPaper: false,
      preferenceLoadingElectronic: false,
      currentAccount: "",
      currentType: "Statements",
      saveBtn: false,
      currentItem: "",
      accountsLoading: false,
      statementsLoading: false,
      statementDownloading: false,
      preferencesLoading: false,
      taxYears: Array.from(new Array(3), (x, j) => j + (new Date().getFullYear() - 3)).reverse(),
      accountPrefs: [],
      expanded: [],
      typePanel: [true],
      allOnline: false,
      defaultRules: {
        rowsPerPage: -1,
        sortBy: "container"
      },
      manageDelivery: false,
      headers: [
        {
          text: "Account Type",
          align: "left",
          sortable: true,
          value: "container"
        },
        {
          text: "Account Name",
          align: "left",
          value: "accountName"
        },
        {
          text: "Account Number",
          // align: "left",
          value: "accountNumberMasked",
          sortable: false
        },
        {
          text: "Statements",
          value: "myDocumentData.deliveryPreference",
          sortable: false
        }
      ],
      typeHeaders: [
        {
          text: "Document Type",
          align: "left",
          sortable: true,
          value: "documentTypeName"
        }
      ],
      accountHeaders: [
        {
          text: "Name",
          align: "left",
          sortable: true,
          value: "name"
        }
      ],
      statementHeaders: [
        {
          text: "Name",
          align: "left",
          sortable: true,
          value: "name"
        }
      ],
      statementSync: {
        rowsPerPage: -1
      },
      rules: {
        required: v => !!v || "Required",
        min: v => v.length >= 8 || v.length === 0 || "Min 8 characters",
        upper: v =>
          /[A-Z]/.test(v) || v.length === 0 || "Must include uppercase letter",
        number: v => /[0-9]/.test(v) || v.length === 0 || "Must include number",
        email: v =>
          /.+@.+/.test(v) || v.length === 0 || "Invalid email address",
        phone: v => v.length === 11 || v.length === 0 || "Phone is invalid",
        match: v =>
          this.migrationInfo.password === this.migrationInfo.password2 ||
          "Passwords don't match"
      },
      newUserAtts: {
        email: "",
        username: "",
        password: "",
        phone: ""
      },
      authUrl: "",
      currentAccounts: [],
      dialog: false,
      editedItem: {},
      clonedItem: {},
      responseStyle: "red",
      tab: null,
      newUrl: false,
      branchLoading: false,
      accountLoading: false,
      actionLoading: false,
      actionTagsLoading: false,
      fullAccountLoading: false,
      system: "",
      retirementDocs: "paper",
      openType: 0,
      getTaxFormsVal: 0,
      phoneResponse: "",
      mfaConfig: {
        mfaTypes: ["TOTP"]
      },
      pagination: {
        descending: true,
        sortBy: "accountName"
      },
      vendor: [],
      accountQueue: [],
      account: [],
      actions: [],
      actionTags: [],
      systems: ["retirement", "avoka", "banking", "wex", "elan", "envestnet"],
      branch: null,
      dashboardReady: false,
      formError: "",
      emailResponse: "",
      branchInfo: "",
      fullAccount: "",
      empty: true,
      token: "",
      authToken: "",
      usernameResponse: "",
      passwordResponse: "",
      color: {
        phone: "light",
        email: "light",
        username: "light",
        password: "light"
      },
      actionHeaders: [
        { text: "Workout", value: "workout" },
        { text: "Email", value: "email" },
        { text: "Phone Number", value: "phoneNumber" }
      ],
      userHeaders: [
        { text: "Username", value: "username" },
        { text: "Alerus 360 ID", value: "alerusId" },
        { text: "CIF", value: "cif" },
        { text: "Email", value: "email" },
        { text: "Phone Number", value: "phone" },
        { text: "Date of Birth", value: "dateOfBirth" }
      ]
    };
  },
  watch: {
    // startMenu(val) {
    //   if (!val && this.currentStart !== this.startDateFormatted) {
    //     this.selectType(this.currentItem)
    //   }
    // },
    // endMenu(val) {
    //   if (!val && this.currentEnd !== this.endDateFormatted) {
    //     this.selectType(this.currentItem)
    //   }
    // },
    allOnline(val) {
      if (val) {
        this.userAccounts.forEach(item => {
          if (item.myDocumentData.deliveryPreference === "paper") {
            item.myDocumentData.deliveryPreference = "electronic"
            item.username = this.user.username
            item.a360id = this.user.attributes["custom:alerus360id"]
            this.accountQueue.push(item)
          } 
        }) 
      }
      else {
        this.accountQueue =  []
      }
    },
    async openType(val) {
      if (val === null) return
      await this.selectType(this.filteredDocTypes[val])
    },
    async getTaxFormsVal(val) {
      
      if (val === null) return
      await this.getTaxForms(this.taxYears[val])
    },
    removeColor(val) {
      if (val === true) {
        Object.keys(this.color).forEach(item => (this.color[item] = "light"));
        this.phoneResponse = "";
        this.passwordResponse = "";
        this.usernameResponse = "";
        this.emailResponse = "";
      }
    }
  },
  async created() {
    if (this.userAccounts.length) return
    this.accountsLoading = true
    this.$store.dispatch("user/checkDocuments", this.mersBranded ? "MERS" : "Alerus")
    let accounts = await this.$store.dispatch("user/getAllAccounts");
    this.currentAccounts = JSON.parse(JSON.stringify(accounts))
    this.accountsLoading = false
    // await this.accountAuth();
    // window.location = await this.getSystem("envestnet");
    // this.getAllEndpoints();
  },
  components: {
    HollowDotsSpinner
  },
  computed: {
    ...mapState("accounts", ["page"]),
    ...mapState("user", ["user", "admin", "links", "mersBranded", "userAccounts", "docTypes", "accountStatements", "userStatements", "userDetails", "currDocTypes"]),
    userAtts: {
      get() {
        return {
          username: this.user.attributes["preferred_username"],
          email: this.user.attributes.email,
          phone: this.user.attributes["phone_number"],
          alerusId: this.user.attributes["custom:alerus360id"],
          cif: this.user.attributes["custom:cif"],
          dateOfBirth: this.user.attributes["custom:dateofbirth"]
        };
      },
      set(val) {
        if (val[0].Name === "preferred_username") {
          this.user.attributes[val[0].Name] = val[0].Value;
        } else {
          this.user.attributes[val[1].Name] = val[1].Value;
        }
      }
    },
    updatedAtts() {
      // return Object.entries(this.newUserAtts).filter(item => item[1])
      return []
    },
    ePrefsAccounts() {
      return this.userAccounts.filter(item => item.myDocumentData.deliveryPreference === "paper" || item.myDocumentData.deliveryPreference === "electronic")
    },
    filteredDocTypes() {
      return this.currDocTypes.filter(item => item.container === this.currentAccount.container).sort((a,b) => a.order > b.order ? 1 : a.order < b.order ? -1 : 0)
    },
    startDateFormatted () {
      return this.formatDate(this.startDate)
    },
    endDateFormatted () {
      return this.formatDate(this.endDate)
    },
    editedPhone() {
      return "+" + this.editedItem.phone;
    },
    filteredUserAccounts() {
      return this.userAccounts.filter(item => item.myDocumentData.deliveryPreferenceAllowedToChange)
    },
    removeColor() {
      if (Object.values(this.newUserAtts).filter(Boolean).length) {
        return true;
      } else return false;
    },
    appColor() {
      return this.mersBranded ? "#33715A" : "#0B2A4A";
    },
    buttonColor() {
      return this.mersBranded ? "#33715A" : "#CD493C";
    },
    borderColor() {
      return this.mersBranded ? "#E8E2D0" : "#40A8CB";
    },
    primaryColor() {
      return this.mersBranded ? "#2F6C55" : "#297994"
    },
    siteStyles() {
      return {
        // '--border-top': this.borderColor,
        '--primary-color': this.primaryColor
        // '--header-color': this.headerColor
      }
    }
  },
  methods: {
    enableManage() {
      this.setAccount()
      this.manageDelivery = true
    },
    showTaxForms() {
      this.setAccount()
      this.getTaxFormsVal = 0
      this.taxFormsVisible = true
      this.getTaxForms(this.taxYears[this.getTaxFormsVal])
    },
    disableManage() {

    },
    lastFour(val) {
      return val.slice(-4)
    },
    capitalize(word) {
      return word.slice(0, 1).toUpperCase() + word.slice(1);
    },
    checkForPlural(item) {
      if (item.charAt(item.length - 1) === "s") {
        item = item.slice(0, item.length - 1)
      }
      return item
    },
    statementSort(items) {
      return items.sort((a,b) => {
        let date1 = new Date(a.documentDate)
        let date2 = new Date(b.documentDate)
        return date1 < date2 ? 1 : date1 > date2 ? -1 : 0 
      })
    },
    formatDate (date) {
      if (!date) return null
      return this.$moment(date).format('MM/DD/YYYY')
    },
    setAccount() {
      if (this.manageDelivery) {
        this.manageDelivery = false
        return
      }
      if (this.taxFormsVisible) {
        this.taxFormsVisible = false
        return
      }
      this.showAccount = false
      this.currentAccount = ""
      this.currentType = ""
      this.currentItem = ""
      this.startDate = this.$moment().subtract(6, "months").toISOString().substr(0, 10)
      this.endDate = this.$moment().toISOString().substr(0, 10)
      this.$store.commit("user/emptyUserStatements")
    },
    async selectAccount(item) {
      if (this.manageDelivery) this.manageDelivery = false
      if (item.myDocumentData.isExternal) {
        this.goToUrl(item.myDocumentData.systemLink)
      }
      else {
        this.currentAccount = item
        this.showAccount = true
        this.openType = 0
        await this.selectType(this.filteredDocTypes[0])
      }
    },
    async selectType(item) {
      if (this.statementsLoading) return
      this.statementsLoading = true
      this.currentItem = item
      this.currentType = item.name
      this.currentStart = this.startDateFormatted
      this.currentEnd = this.endDateFormatted
      this.$store.commit("user/emptyUserStatements")
      await this.$store.dispatch("user/searchAccount", {
        keyAccountNumber: this.currentAccount.alerusAccountKey,
        filterId: item.documentId,
        filterType: item.filterType,
        startDate: this.startDateFormatted,
        endDate: this.endDateFormatted
      })
      this.statementsLoading = false
    },
    async getTaxForms(year) {
      this.$store.commit("user/emptyUserStatements")
      this.statementsLoading = true
      await this.$store.dispatch("user/searchAccount", {
        filterId: 3,
        filterType: 2,
        taxYear: year
      })
      // sort alpha
      this.userStatements.sort((a, b) => a.documentTypeName.localeCompare(b.documentTypeName))
      this.statementsLoading = false
    },

    /**
     * Format the display output of a document in the list of documents
     * @param {*} document 
     */
    formatDocumentName(document) {
      if (document.documentTypeName === "Wealth Statement") {
        let start, end, dates

        start = document.details.some(x => x.id === "1048") ? document.details.find(x => x.id === "1048").value : null
        end = document.details.some(x => x.id === "1049") ? document.details.find(x => x.id === "1049").value : null

        if (start && end) {
          dates = `${start} to ${end}`
        }

        return `${dates ? dates + " - " : ""}${document.documentTypeName}`
      } else {
        return `${document.documentDate} - ${document.documentTypeName}`
      }
    },

    /**
     * Format the display output of a Tax Form
     * @param {*} document 
     */
    formatTaxDocumentName(document) {
      let name = document.documentTypeName
      if (document.details.some(x => x.id === "149")) {
        name = name + ` ${document.details.find(x => x.id === "149").value}`
      }
      return name
    },

    /**
     * Fetch a statement pdf from the server
     * @param {*} item 
     * @param {*} name 
     * @param {*} i 
     */
    async requestStatement(item, name, i) {
      this.clicked = i
      this.statementDownloading = true
      let res = await this.$store.dispatch("user/requestStatement", item.documentId)
      this.statementDownloading = false
      this.clicked = null
      if (res) {
        this.openStatement(res, name)
      }
      else {
        console.log("error opening statement")
      }
    },
    async openStatement(data, name) {
      let downloadLink = document.createElement("a");
      downloadLink.href = `data:application/pdf;base64,${data}`
      downloadLink.download = `${name}.pdf`
      downloadLink.click();
      // window.open(`data:application/pdf;base64,${data}`)
    },
    updateAllAccounts(prop) {
      if (prop === "paper") {
        this.preferenceLoadingPaper = true
      }
      else {
        this.preferenceLoadingElectronic = true
      }
      this.ePrefsAccounts.forEach(item => {
        if (item.myDocumentData.deliveryPreference !== prop) {
          this.updateAccount(item)
          this.$store.commit("user/updateEPreference", {
            index: item.alerusAccountKey,
            prop
          })
        }
      })
      if (prop === "paper") {
        this.preferenceLoadingPaper = false
      }
      else {
        this.preferenceLoadingElectronic = false
      }
    },
    checkUpdate(item) {
      if (item.container === "401K") {
        this.$snotify.confirm("All Retirement Accounts must have the same delivery preference. Are you sure?", "", {
          buttons: [
            {text: 'Yes', action: (toast) => {
              this.$store.commit("user/updateSinglePreference", item.myDocumentData.deliveryPreference === "paper" ? "electronic" : "paper")
              this.updateAccount(item)
              this.$snotify.remove(toast.id)
            }},
            {text: 'No', action: (toast) => {
               this.$snotify.remove(toast.id)
              return
            }}
          ],
          position: "centerCenter",
          backdrop: .6,
          preventDuplicates: true
        })
      }
      else {
        this.updateAccount(item)
      }
    },
    updateAccount(item) {
      item.username = this.user.username
      item.a360id = this.user.attributes["custom:alerus360id"]
      let find = this.accountQueue.find(acc => acc.alerusAccountKey === item.alerusAccountKey)
      if (!find) {
        this.accountQueue.push(item)
      }
      else {
        let ind = this.accountQueue.findIndex(acc => acc.alerusAccountKey === item.alerusAccountKey)
        if (this.accountQueue[ind].myDocumentData.deliveryPreference === item.myDocumentData.deliveryPreference) {
          this.accountQueue.splice(ind, 1)
        }
      }
    },
    async sendPreferenceUpdate() {
      this.preferencesLoading = true
      if (this.accountQueue.length == 0) {
        this.preferencesLoading = false
        return
      }
      let res = await this.$store.dispatch("user/updateMyprofile", {
        func: "updatePreferences",
        arguments: JSON.stringify(this.accountQueue)
      })
      if (res) {
        this.accountQueue = []
        this.$snotify.success("Documents updated successfully")
      }
      else {
        this.$snotify.error("Error updating documents")
      }
      this.preferencesLoading = false
    },
    goToUrl(url) {
      window.open(url, "_blank");
    },
    resetAccount() {
      this.dialog = false;
      this.emailError = "";
      this.phoneError = "";
    },
    async createEdits() {
      let changes = this.findDifference();
      let updated = await this.$store.dispatch("user/updateUser", {
        newAtts: changes
      });
      if (updated === "Error Saving Changes") {
        this.formError = updated;
      } else this.dialog = false;
    },
    async changePassword() {
      if (!this.$refs.form.validate() || !this.newUserAtts.password) return;
      let res = await this.$store.dispatch(
        "user/updateUserPass",
        this.newUserAtts.password
      );
      if (res) {
        this.responseStyle = "green";
        this.passwordResponse = `password updated successfully`;
        this.color.password = "green";
        this.newUserAtts.password = "";
      } else {
        this.responseStyle = "red";
        this.passwordResponse = "Error updating password";
      }
    },
    async changeAtt(type) {
      if (!this.$refs.form.validate() || !this.newUserAtts[type]) return;
      let val;
      let responseType = `${type}Response`;
      if (type === "email") {
        val = [
          {
            Name: "email_verified",
            Value: true
          },
          {
            Name: "email",
            Value: this.newUserAtts.email
          }
        ];
      } else if (type === "phone") {
        val = [
          {
            Name: "phone_number_verified",
            Value: true
          },
          {
            Name: "phone_number",
            Value: `+${this.newUserAtts.phone}`
          }
        ];
      } else if (type === "username") {
        val = [
          {
            Name: "preferred_username",
            Value: this.newUserAtts.username
          }
        ];
      }

      let res = await this.$store.dispatch("user/updateUserAtt", val);
      if (res) {
        this.responseStyle = "green";
        this[responseType] = `${type} updated successfully`;
        this.color[type] = "green";
        this.newUserAtts[type] = "";
        this.userAtts = val;
      } else {
        this.responseStyle = "red";
        this[responseType] = `Error updating ${type}`;
      }
    },
    async updateUser() {
      this.emailError = "";
      this.phoneError = "";
      // Return if any errors are found or if fields are the same
      if (
        this.errors.items.length ||
        (this.clonedItem.phone === this.editedPhone &&
          this.editedItem.email === this.clonedItem.email)
      )
        return;

      // Check email and phone
      if (
        (this.editedItem.email !== this.clonedItem.email &&
          this.clonedItem.phone === this.editedPhone) ||
        (this.editedItem.email !== this.clonedItem.email &&
          this.clonedItem.phone !== this.editedPhone)
      ) {
        if (
          await this.$store.dispatch(
            "user/checkAllEmails",
            this.editedItem.email
          )
        ) {
          this.emailError = "Email already in use";
          return;
        } else this.createEdits();
      } else if (
        this.clonedItem.phone !== this.editedPhone &&
        this.editedItem.email === this.clonedItem.email
      ) {
        this.createEdits();
      }
    },
    findDifference() {
      let vm = this;
      let changes = Object.keys(this.clonedItem).filter(prop => {
        if (prop === "phone") {
          return this.clonedItem[prop] !== this.editedPhone;
        } else return this.clonedItem[prop] !== this.editedItem[prop];
      });
      return changes.map(item => {
        if (item === "phone") {
          return {
            Name: "phone_number",
            Value: this.editedPhone
          };
        } else
          return {
            Name: "email",
            Value: this.editedItem[item]
          };
      });
    },

    updateAtts() {
      this.editedItem = {
        username: this.userAtts["username"],
        email: this.userAtts["email"],
        phone: this.userAtts["phone"]
      };
      this.clonedItem = { ...this.editedItem };
      this.dialog = true;
    },
    async getAllEndpoints() {
      await Promise.all([
        this.getAccount(),
        this.getCallToAction(),
        this.getActionTags(),
        this.getFullAccount()
      ]);
      this.dashboardReady = true;
    },
    async accountAuth() {
      let { data } = await $authUser.get(`/accountAuth`, {
        headers: {
          Authorization: `Bearer ${this.user.signInUserSession.idToken.jwtToken}`
        }
      });
      this.authToken = data;
    },
    formatName(name) {
      let [last, first] = name.split(",");
      return `${first} ${last}`;
    },
    formatAccountName(name) {
      return;
    },
    async getAccount() {
      this.accountLoading = true;
      let { data: account } = await $authUser.get(`/accounts`, {
        headers: {
          Authorization: `Bearer ${this.authToken}`
        }
      });
      this.account = account;
      this.accountLoading = false;
    },
    async getCallToAction() {
      this.actionLoading = true;
      let { data: actions } = await $authUser.get(`/callToAction`, {
        headers: {
          Authorization: `Bearer ${this.authToken}`
        }
      });
      this.actions = actions;
      this.actionLoading = false;
    },
    async getActionTags(userId = 444455555, accountId = "00001555555") {
      this.actionTagsLoading = true;
      let { data: actionTags } = await $authUser.get(
        `/accounts/${accountId}/actionTags`,
        {
          headers: {
            Authorization: `Bearer ${this.authToken}`
          }
        }
      );
      this.actionTags = actionTags;
      this.actionTagsLoading = false;
    },
    async getFullAccount() {
      this.fullAccountLoading = true;
      let { data: full } = await $authUser.get(
        `https://api.alerus.com/accounts/00001555555?userHandle=444455555&participantId="partipandID"&planNumber=000015`,
        {
          headers: {
            Authorization: `Bearer ${this.authToken}`
          }
        }
      );
      this.fullAccount = full;
      this.fullAccountLoading = false;
    },
    async branchLookup(branchZip) {
      let { data: branch } = await $authUser.get(
        `/branchCodeLookup?zipCode=${branchZip}`
      );
      this.branchInfo = branch;
    },
    async getSystem(system = this.system) {
      this.newUrl = true;
      let { data: authSystem } = await $authUser.get(
        `/getSystemLink?system=${system}`,
        {
          headers: {
            Authorization: `Bearer ${this.user.signInUserSession.idToken.jwtToken}`
          }
        }
      );
      console.log(authSystem);
      this.authUrl = `https://applanding.alerus.com/?auth=${authSystem}`;
      this.newUrl = false;
      return `https://applanding.alerus.com/?auth=${authSystem}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.doc-delivery {
  .user-accounts {
    border-top: 1px solid #ddd;
  }
}
.all-online {
  padding: 1rem;
  background-color: #F4F5F8;
  margin-bottom: 1.5rem;
}
.welcome-text {
  span {
    top: initial;
    color: initial;
    font-weight: bold;
  }
}
.sub-profile-header {
  color: var(--primary-color);
  font-size: 1.1rem;
  cursor: pointer;
}
.account-statement {
  color: var(--primary-color);
  font-size: 1.1rem;
  font-weight: 600;
  padding: .75rem 1rem;
  .statement-name {
    display: inline-block;
    cursor: pointer;
  }
  i {
    font-size: 20px !important;
  }
}
.type-name {
  color: var(--primary-color);
  font-weight: 600;
  font-size: 1.1rem;
}
.doc-type {
  margin-bottom: 1rem;
  border-top: none !important;
}
.account-row {
  display: flex;
  border-bottom: 1px solid #ddd;
  align-items: center;
  padding: 1rem 0;
  justify-content: space-between;
}
.delivery-pref {
  min-width: 40%;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: flex-end;
  .radio-label {
    font-size: 1.1rem;
    color: #212529;
  }
}
.account-number {
  color: #6E6E6E;
  margin-top: 0.25rem;
}
.account-name {
  cursor: pointer;
  font-size: 1.25rem;
  color: var(--primary-color);
  font-weight: 600;
}
.move-left {
  margin-left: -24px;
  cursor: pointer;
  color: var(--primary-color);
  i {
    vertical-align: bottom;
  }
}
.v-list__tile__title {
  font-size: 1.05rem;
}
.no-scroll {
  overflow: hidden;
}
h3 {
  font-weight: initial;
}
.theme--light .v-list__tile__sub-title {
  color: #40a7c7;
}
.userProps {
  position: relative;
  .edit {
    position: absolute;
    right: 1rem;
    top: 1rem;
    z-index: 1;
  }
  .v-card {
    // cursor: pointer;
    // &:hover {
    //   background-color: #eee;
    // }
    // .v-list {
    //   &:hover {
    //     background-color: #eee;
    //   }
    // }
  }
}
.v-card__title {
  background-color: #0C2B4A;
  color: #fff;
  font-size: 1.25rem;
}
span {
  color: red;
  position: relative;
  top: -1rem;
}
.user-card {
  width: 100%;
}
h4 {
  font-weight: initial;
}
h2 {
  font-weight: initial;
}
td{
  a{
    color: #0C2B4A;
  } 
}
.pdf {
  cursor: pointer;
  background-color: #f3f3f3;
}
.multi-accounts{
  display: flex;
  justify-content: space-between;
}
.user-docs {
  .active-type {
    // background-color: #eee;
    background-color: #0C2B4A !important;
    color: #fff;
  }
  /deep/ thead {
    th.active {
      background-color: #E1E1E1;
    }
  }
  tbody {
    tr:not(.active-type):hover {
      background: #eeeeee !important;
    }
  }
}
.pointer {
  cursor: pointer;
}
.mers{
  background-color: #33715A !important;
}
.radio-label{
  font-size: 13px;
}
.statements /deep/ {
  thead {
    tr:first-child {
      display: none;
    }
  }
}
/deep/ .snotify-confirm{
  background-color: #0e294a;
}
/deep/ .url-btn{
  .v-btn__content{
    font-size: .9rem;
  }
}

</style>
<style lang="scss">
.snotify-success {
  background-color: #5fbc9a;
}
.profile-header {
  h1 {
    color: var(--primary-color);
  }
}
.dot {
  background-color: var(--border-color) !important;
}
.manage-documents {
  align-items: center;
  margin-top: 1.5rem;
  p {
    font-size: 1.2rem;
  }
}
.button-row {
  text-align: end;
  margin-top: 1rem;
}
.loading-profile {
  width: 70%;
  margin: 0 auto;
  .v-progress-linear {
    margin: 0;
  }
}
.external {
  .v-btn__content {
    font-size: 1rem;
  }
}
  .online {
    label {
      font-weight: 600;
      color: #212529 !important;
    }
  }
  .group-btn {
    margin-top: 1.5rem;
  }
  .v-expansion-panel__header {
    background-color: #F4F5F8;
  }
  .v-expansion-panel {
    box-shadow: none;
  }
  .v-expansion-panel__container--active {
    .v-expansion-panel__header {
      background-color: var(--primary-color);
      .type-name {
        color: #fff;
      }
      .v-expansion-panel__header__icon {
        i {
          color: #fff !important;
          caret-color: #fff !important;
        }
      }
    }
  }
  .date-pick {
    margin-top: 0;
    padding-top: 0;
    .v-input__slot {
      margin-bottom: 0;
      border: 1px solid #ddd;
      height: 60px;
      padding: 16px;
      cursor: pointer !important;
      input {
        cursor: pointer;
        font-weight: 600;
      }
      &::before {
        display: none;
      }
    }
    .v-input__control {
      cursor: pointer;
    }
  }
  @media (max-width: 599px) {
    .account-name {
      font-size: 1.1rem !important;
    }
    .main-profile {
      .main-blue {
        font-size: 1.5rem;
        margin-bottom: 1rem
      }
    }
  }
</style>